import { render, staticRenderFns } from "./headMenu1.vue?vue&type=template&id=3aa3712b&scoped=true"
import script from "./headMenu1.vue?vue&type=script&lang=js"
export * from "./headMenu1.vue?vue&type=script&lang=js"
import style0 from "./headMenu1.vue?vue&type=style&index=0&id=3aa3712b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3712b",
  null
  
)

export default component.exports